import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, ArrowRight } from "lucide-react";
import { motion } from "framer-motion";
import { reGuides, dl } from "@/lib/docstate";

export default function DocstateGuides() {
  const [guides, setGuides] = useState(null);
  useEffect(() => { window.scrollTo(0, 0); reGuides().then(setGuides).catch(() => setGuides([])); }, []);

  return (
    <div className="ds-bg min-h-screen pt-16" data-testid="docstate-guides">
      <div className="mx-auto max-w-7xl px-4 py-14 sm:px-8 lg:px-12">
        <p className="ds-eyebrow">Area Guides</p>
        <h1 className="ds-display mt-2 text-4xl font-medium text-white sm:text-5xl">Explore Dubai's Communities</h1>
        <p className="mt-4 max-w-2xl text-lg font-light text-[#C9BBB2]">Insider knowledge on the neighbourhoods that matter — lifestyle, prices and investment potential.</p>

        {!guides ? (
          <div className="mt-16 flex justify-center"><Loader2 className="h-8 w-8 animate-spin text-[#C9A24B]" /></div>
        ) : guides.length ? (
          <div className="mt-12 grid gap-8 md:grid-cols-2 lg:grid-cols-3">
            {guides.map((g, i) => (
              <motion.div key={g.id} initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}>
                <Link to={dl(`/area-guides/${g.slug}`)} className="group relative block h-80 overflow-hidden rounded-xl" data-testid={`guide-card-${g.slug}`}>
                  <img src={g.cover} alt={g.community} className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0B0B0C] via-[#0B0B0C]/40 to-transparent" />
                  <div className="absolute bottom-0 p-6">
                    <h2 className="ds-display text-2xl text-white">{g.community}</h2>
                    <p className="mt-1 line-clamp-2 text-sm font-light text-[#C9BBB2]">{g.intro}</p>
                    <span className="mt-3 inline-flex items-center gap-1 text-xs text-[#C9A24B]">Read guide <ArrowRight className="h-3 w-3" /></span>
                  </div>
                </Link>
              </motion.div>
            ))}
          </div>
        ) : (
          <p className="mt-12 text-sm font-light text-[#9D8D83]">Area guides are coming soon.</p>
        )}
      </div>
    </div>
  );
}
